import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import * as AdminModels from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';
import { invalidateIndustryAutomationTemplateQuery } from './useIndustryAutomationTemplateQuery';
import { invalidateIndustryAutomationTemplatesQuery } from './useIndustryAutomationTemplatesQuery';

interface IParams {
	templateId: string;
	industry: Api.Industry;
	automationTemplate?: Api.IAutomationTemplate;
}

export function usePublishIndustryAutomationTemplateMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (res: AdminModels.ISystemAutomationTemplate) => void;
} = {}) {
	const userSession = useUserSession<AdminUserSessionContext>();
	return useMutation({
		mutationFn: async ({ templateId, industry, automationTemplate }: IParams) => {
			if (automationTemplate?.status === Api.TemplateStatus.Draft || automationTemplate?.draft) {
				await userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
					`admin/AutomationTemplate/${templateId}/commitDraft`,
					'PUT'
				);
			}

			const result = await userSession.webServiceHelper.callAsync<AdminModels.ISystemAutomationTemplate>(
				`admin/AutomationTemplate/${templateId}/publish?industry=${encodeURIComponent(industry)}`,
				'PUT'
			);

			return result;
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateIndustryAutomationTemplateQuery(variables.templateId);
			invalidateIndustryAutomationTemplatesQuery(variables.industry);
			onSuccess?.(data);
		},
	});
}
